export default __webpack_public_path__ + "static/media/nutrionist@2x.456c0820.png";